import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';
import { ManagementCommonModule } from '../management-common/management-common.module';
import { SharedModule } from '../shared-module/shared.module';

import {
    DxBoxModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxDropDownBoxModule,
    DxDataGridModule,
    DxContextMenuModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxPopupModule,
    DxScrollViewModule,
    DxFormModule,
    DxToolbarModule
} from 'devextreme-angular';

import { ManageVendorAccountsComponent } from './components/manage-vendor-accounts/manage-vendor-accounts.component';
import { VendorAccountEditorComponent } from './components/vendor-account-editor/vendor-account-editor.component';
import { VendorAccountHistoryComponent } from './components/vendor-account-history/vendor-account-history.component';
import { VendorAccountNotesComponent } from './components/vendor-account-notes/vendor-account-notes.component';
import { VendorAccountConfigurationComponent } from './components/vendor-account-configuration/vendor-account-configuration.component';
import { SharedVendorManagementModule } from '../vendor-management/shared-vendor-management-module/shared-vendor-management.module';

@NgModule({
    declarations: [
        ManageVendorAccountsComponent,
        VendorAccountEditorComponent,
        VendorAccountHistoryComponent,
        VendorAccountNotesComponent,
        VendorAccountConfigurationComponent
    ],
    exports: [
        ManageVendorAccountsComponent,
        VendorAccountEditorComponent,
        VendorAccountNotesComponent,
        VendorAccountConfigurationComponent
    ],
    imports: [
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        ManagementCommonModule,
        DxBoxModule,
        DxLoadPanelModule,
        DxDropDownBoxModule,
        DxDataGridModule,
        DxButtonModule,
        DxContextMenuModule,
        DxValidationGroupModule,
        DxValidatorModule,
        DxTextBoxModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        DxSwitchModule,
        DxPopupModule,
        DxScrollViewModule,
        DxFormModule,
        DxToolbarModule,
        SharedVendorManagementModule,
        SharedModule
    ]
})
export class VendorModule {}
